import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';

import { useDispatch } from 'react-redux';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { Box, Grid } from '@material-ui/core';
import { ADGMSelect } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';
import isEmpty from 'lodash/isEmpty';
import styles from './styles';
import { ADGMImage } from '../../components';

const Bankdetails = ({ classes, Banklists, setContractDetails, contractDetails, title, isEditable, disabled }) => {
  const dispatch = useDispatch();
  const lang = localStorage.getItem('lang');

  if (!isEditable && isEmpty(contractDetails?.selectbank)) return null;

  const BankLookup = Banklists?.items?.map(item => {
    return {
      value: item?.id,
      label: lang === 'en' ? item?.nameEn : item?.nameAr,
      customerSupportEmail: item?.customerSupportEmail,
      callCenter: item?.callCenter,
    };
  });

  const handleInputChange = (key, data) => {
    if (!data) {
      dispatch(
        setContractDetails({
          key,
          value: null,
        }),
      );
      return;
    }
    dispatch(
      setContractDetails({
        key,
        value: {
          ...contractDetails?.selectbank,
          bankId: data.value,
          callCenter: data.callCenter,
          customerSupportEmail: data.customerSupportEmail,
          nameEn: data.label,
        },
      }),
    );
  };

  return (
    <Box className={(classes.paperCardFrame, classes.marginTop)}>
      <div className={classes.titleHead}>
        <div className={classes.title}>
          <span>{isEditable ? keyEmptyCheck('select_bank') : keyEmptyCheck(title ?? 'bank_details')}</span>
        </div>
      </div>
      <Grid container className={classes.container}>
        {isEditable ? (
          <>
            <Grid item xs={12} md={12}>
              <div>
                <ADGMSelect
                  type='select'
                  label={keyEmptyCheck('bank')}
                  required
                  fullwidth='true'
                  name='selectbank'
                  value={contractDetails?.selectbank?.bankId ? contractDetails?.selectbank?.bankId : ''}
                  onChange={handleInputChange}
                  options={BankLookup}
                  customClasses={{ select: classes.adgmSelect }}
                  disabled={disabled}
                />
              </div>
            </Grid>
            {contractDetails?.selectbank?.bankId && (
              <>
                <Grid item xs={12}>
                  <hr className={classes.hr} />
                </Grid>
                <Grid item xs={12} md={3}>
                  <ADGMItemDetails
                    label='call_centre'
                    value={contractDetails?.selectbank?.callCenter || contractDetails?.selectbank?.phone}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <ADGMItemDetails
                    label='customer_support_email'
                    value={contractDetails?.selectbank?.customerSupportEmail || contractDetails?.selectbank?.email}
                  />
                </Grid>
              </>
            )}
          </>
        ) : (
          <Grid container alignItems='center' spacing={2}>
            <Grid item>
              <ADGMImage name='Company_avatar.svg' alt='Company_avatar' className={classes.avatarImg} />
            </Grid>
            <Grid item xs={12} md={3}>
              <ADGMItemDetails
                label='bank_name'
                value={lang === 'en' ? contractDetails?.selectbank?.nameEn : contractDetails?.selectbank?.nameAr}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <ADGMItemDetails
                label='call_centre'
                value={contractDetails?.selectbank?.phone || contractDetails?.selectbank?.callCenter}
              />
            </Grid>
            <Grid item xs={12} md='auto'>
              <ADGMItemDetails
                label='customer_support_email'
                value={contractDetails?.selectbank?.email || contractDetails?.selectbank?.customerSupportEmail}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
Bankdetails.propTypes = {
  classes: PropTypes.object.isRequired,
  Banklists: PropTypes.object.isRequired,
  setContractDetails: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  contractDetails: PropTypes.object.isRequired,
  title: PropTypes.string,
};

Bankdetails.defaultProps = {
  title: null,
  application: null,
};

export default withStyles(styles)(Bankdetails);
